import type { ProcessPlanStatus, StageInputSource } from "@/features/planning/types";

export const PLAN_STATUSES: { value: ProcessPlanStatus; label: string }[] = [
  { value: "draft", label: "Draft" },
  { value: "planned", label: "Planned" },
  { value: "in_progress", label: "In progress" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

export const INPUT_SOURCES: { value: StageInputSource; label: string }[] = [
  { value: "inventory", label: "Inventory" },
  { value: "previous_stage", label: "Previous stage" },
];

export function labelFor<T extends string>(
  options: { value: T; label: string }[],
  value: T | string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}

export function statusTone(
  status: ProcessPlanStatus,
): "success" | "neutral" | "warning" | "danger" {
  if (status === "completed") return "success";
  if (status === "planned" || status === "in_progress") return "warning";
  if (status === "cancelled") return "danger";
  return "neutral";
}

export function canEditPlan(status: ProcessPlanStatus) {
  return status === "draft" || status === "planned";
}
